/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {CreateApplication, CreateApplicationInit} from "@/model/request/application/createApplication.ts";
import {notification} from "@/store/modules/notification.ts";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {NewApplicationModal} from "./validation/ApplicationValidation.ts";
import {BaseInput} from "../input/BaseInput.tsx";
import {BaseSelect} from "../input/BaseSelect.tsx";
import {application,} from "@/store/modules/application.ts";
import {RootState} from "@/store/modules";

export type NewModuleType = {
    onClose: () => void
    data?: any
};

export default function NewApplicationForm({onClose, data}: Readonly<NewModuleType>) {
    const dispatch = useDispatch<any>();
    const applicationState = useSelector((state: RootState) => state.application);
    const workspaceState = useSelector((state: RootState) => state.workspace);


    const applicationLanguage = [
        {value: "", label: "Select Language", disabled: true},
        {value: "Java", label: "Java"},
        {value: "Python", label: "Python"},
        {value: "Kotlin", label: "Kotlin"},
        {value: "JavaScript", label: "JavaScript"},
    ];


    type Framework = { value: string, label: string };

    const frameworks: { [key: string]: Framework[] } = {
        Java: [
            {value: "SpringBoot", label: "SpringBoot"}
        ],
        Python: [
            {value: "Django", label: "Django"}
        ],
        JavaScript: [
            {value: "Node.js", label: "Node.js"}
        ],
        Kotlin: [
            {value: "SpringBoot", label: "SpringBoot"}
        ]
    };


    const showMessage = (
        response: any,
        title: "error" | "Success" = "Success",
        type: "error" | "success" = "success"
    ) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: type,
                        title: title,
                        body: response.responseMessage,
                    })
                )
                // dispatch(application.action.readByWorkspaceId({applicationWorkspaceId: workspaceState?.selectedWorkspace?.workspaceId}))
                dispatch(application.action.readApplication())
            }
        );
        onClose()
    };

    const handleSubmit = async (value: CreateApplication) => {
        const request = {
            ...value, applicationWorkspaceId: workspaceState?.selectedWorkspace?.workspaceId,
            applicationCloudProvider: "AWS"
        }
        const updateRequest = {
            ...value,
            applicationWorkspaceId: workspaceState?.selectedWorkspace?.workspaceId,
            applicationId: applicationState?.selectedApplication?.applicationId,
            applicationStatus: applicationState?.selectedApplication?.applicationStatus,
        }
        console.log(updateRequest)

        data ? await dispatch(
                application.action.updateApplication({
                    data: updateRequest,
                    onSuccess: (response: any) => showMessage(response, "Success", "success"),
                    onError: (response: any) => showMessage(response, "error", "error"),
                })
            ) :
            await dispatch(
                application.action.createApplication({
                    data: request,
                    onSuccess: (response: any) => showMessage(response, "Success", "success"),
                    onError: (response: any) => showMessage(response, "error", "error"),
                })
            );
    };


    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: data ? data : CreateApplicationInit,
        validationSchema: NewApplicationModal.create,
    });

    return (
            <form onSubmit={formik.handleSubmit}>
                <div className="div-block-4">
                    <label htmlFor="applicationName" className="field-label">
                        Name
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name={"applicationName"}
                        data-name="applicationName"
                        placeholder=""
                        type="text"
                        id="applicationName"
                    />
                </div>
                <div className="div-block-4">
                    <label htmlFor="name-2" className="field-label">
                        Description
                    </label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name="applicationDescription"
                        data-name="applicationDescription"
                        placeholder=""
                        type="text"
                        id="applicationDescription"
                    />
                </div>
                <div>
                    <div className="flex-2">
                        <div className="flex-item">
                            <label htmlFor="name-2" className="field-label">
                                Architecture
                            </label>
                            <BaseSelect
                                formik={formik}
                                className="form_input w-select"
                                name="applicationArchitecture"
                                data-name="applicationArchitecture"
                                id="applicationArchitecture"
                                items={[
                                    {value: "", label: "Select Architecture", disabled: true},
                                    {value: "Web App", label: "Web App"},
                                    {value: "Mobile App", label: "Mobile App"},
                                ]}
                            />
                        </div>
                        <div className="flex-item">
                            <label htmlFor="name-1" className="field-label">Language</label>
                            <BaseSelect
                                formik={formik}
                                className="form_input w-select"
                                name="applicationLanguage"
                                data-name="applicationLanguage"
                                id="applicationLanguage"
                                items={applicationLanguage}
                            />
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="flex-2">
                        <div className="flex-item">
                            <label htmlFor="name-2" className="field-label">
                                Framework
                            </label>
                            <BaseSelect
                                formik={formik}
                                className="form_input w-select"
                                name="applicationFramework"
                                data-name="applicationFramework"
                                id="applicationFramework"
                                displayName="Framework"
                                items={frameworks[formik.values.applicationLanguage]}
                                disabled={!frameworks[formik.values.applicationLanguage]}
                            />
                        </div>
                        <div className="flex-item">
                            <label htmlFor="name-1" className="field-label">Cloud Provider</label>
                            <BaseSelect
                                formik={formik}
                                className="form_input w-select"
                                name="applicationCloudProvider"
                                data-name="applicationCloudProvider"
                                id="applicationCloudProvider"
                                displayName="Cloud Provider"
                                items={[
                                    {value: "Microsoft Azure", label: "Microsoft Azure"},
                                    {value: "Google Cloud", label: "Google Cloud"},
                                    {value: "AWS", label: "AWS"},
                                ]}
                            />
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="flex-2">
                        <div className="flex-item">
                            <label htmlFor="name-2" className="field-label">
                                Cloud Compute Type
                            </label>
                            <BaseSelect
                                formik={formik}
                                className="form_input w-select my-select"
                                name="applicationCloudCompute"
                                data-name="applicationCloudCompute"
                                id="applicationCloudCompute"
                                displayName="Cloud Compute"
                                items={[{value: "Serverless", label: "Serverless"}]}
                            />
                        </div>
                        <div className="flex-item">
                            <label htmlFor="name-1" className="field-label">Database</label>
                            <BaseSelect
                                formik={formik}
                                className="form_input w-select"
                                name="applicationDatabase"
                                data-name="applicationDatabase"
                                id="applicationDatabase"
                                items={[
                                    {value: "", label: "Select Database", disabled: true},
                                    {value: "PostgreSQL", label: "PostgreSQL"},
                                    {value: "Microsoft SQL", label: "Microsoft SQL"},
                                    {value: "MySQL", label: "MySQL"},
                                ]}
                            />
                        </div>
                    </div>
                </div>
                <div className="div-block-5 div-flex">
                    <BaseInput
                        type="submit"
                        formik={formik}
                        className="button w-button"
                        loading={applicationState.loading}
                        value={!data ? "Add new application" : "Update application"}
                    />
                    <a className="button is-secondary w-button" onClick={onClose}>Cancel</a>
                </div>
            </form>
    );
}
